import React, { useState } from "react";
import SwitchToDesktopModal from "../medium/SwitchToDesktopModal";
import { useHistory } from "react-router-dom";
import { IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const MobileMenu = ({ toggleMenu }) => {
  const history = useHistory();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="header-mobile">
      <IconButton
        className="close"
        aria-label="close"
        onClick={() => toggleMenu(false)}
      >
        <CloseIcon />
      </IconButton>

      <div
        className="item"
        onClick={() => {
          history.push("/");
          toggleMenu(false);
        }}
      >
        Home
      </div>
      <div
        className="item"
        onClick={() => {
          history.push("/search/1/posts");
          toggleMenu(false);
        }}
      >
        Search
      </div>
      <div
        className="item-create-post"
        onClick={() => {
          showModal();
        }}
      >
        Create Post
      </div>

      <SwitchToDesktopModal
        handleOk={handleOk}
        showModal={showModal}
        isModalOpen={isModalOpen}
      />
    </div>
  );
};

export default MobileMenu;
